<template>
  <div class="content-container" v-if="this.orderNo">
    <div v-if="isApproval">
      <el-button v-if="isAudit" type="primary" size="" @click="orderAudit">审批</el-button>
      <auth-dialog :dialog-visible="authDialogVisible" @update:dialogVisible="updateAuthDialogVisible"
                   @submit-success="operationComplete('audit')"
                   :order-no="orderNo"/>
    </div>
    <div v-else>
      <el-button v-if="isPayment()" type="primary" @click="orderPay">放款</el-button>
      <el-button v-if="isClear()" type="primary" @click="orderClear">结清</el-button>
      <el-button v-if="isArchive()" type="primary" @click="orderArchive">归档</el-button>
      <el-button v-if="isRepay()" type="primary" @click="orderRepay">还款</el-button>
      <el-button v-if="isCancel()" type="primary" @click="orderCancel">取消订单</el-button>
      <order-pay-dialog :dialog-visible="paydialogVisible" @update:dialogVisible="updatepayDialogVisible"
                        :order-no="orderNo" @operate:success="operationComplete('pay')"></order-pay-dialog>
      <order-archive-dialog :dialog-visible="archivedialogVisible" @update:dialogVisible="updateArchiveDialogVisible"
                            :order-no="orderNo" @operate:success="operationComplete('achive')"></order-archive-dialog>
      <order-repay-dialog :dialog-visible="repaydialogVisible" @update:dialogVisible="updateRepayDialogVisible"
                          :order-no="orderNo" @operate:success="operationComplete('repay')"></order-repay-dialog>
      <order-clear-dialog :dialog-visible="cleardialogVisible" @update:dialogVisible="updateClearDialogVisible"
                          :order-no="orderNo" @operate:success="operationComplete('clear')"/>
    </div>
  </div>
</template>
<script>
import {hasPer} from "@/utils/common";
import OrderPayDialog from "@/views/order/info/dialog/orderPayDialog.vue";
import OrderArchiveDialog from "@/views/order/info/dialog/orderArchiveDialog.vue";
import AuthDialog from "@/views/approval/task/auditDialog.vue";
import OrderRepayDialog from "@/views/order/info/dialog/orderRepayDialog.vue";
import OrderClearDialog from "@/views/order/info/dialog/orderClearDialog.vue";
import {orderCancel} from "@/api/order/order";
import {infoMsg, successMsg} from "@/utils/message";

export default {
  name: "orderOperation",
  components: {OrderClearDialog, OrderRepayDialog, AuthDialog, OrderArchiveDialog, OrderPayDialog},
  props: {
    orderDetail: {
      type: Object,
      required: true
    },
    isApproval: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      paydialogVisible: false,
      archivedialogVisible: false,
      authDialogVisible: false,
      repaydialogVisible: false,
      cleardialogVisible: false
    }
  },
  computed: {
    orderNo() {
      return this.orderDetail.order?.orderNo
    }
  },
  watch:{
    orderDetail() {
      this.$nextTick(() => {
        if (!this.hasContent()){
          this.$emit('operation:hidden')
        }
      })
    }
  },
  methods: {
    orderCancel(){
      let orderCode = this.orderNo;
      this.$confirm('确定取消订单【' + orderCode + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderCancel(orderCode).then(() => {
          successMsg('操作成功')
          this.$emit('operation:complete', "cancel")
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    hasContent() {
      if (!this.orderNo) {
        return false
      }
      return this.isPayment() || this.isArchive() || this.isRepay() || this.isClear() || this.isAudit() || this.isCancel()
    },
    isPayment() {
      return hasPer('order:payment') && this.orderDetail.order.status === 'loanWait' && String(this.orderDetail.order.isLending) === '0'
    },
    isArchive() {
      return hasPer('order:archiving') && this.orderDetail.order.status === 'saveWait' && String(this.orderDetail.order.isArchive) === '0'
    },
    isRepay() {
      return hasPer('order:repay') && String(this.orderDetail.order.isLending) === '1'
    },
    isClear() {
      return hasPer('order:clear') && String(this.orderDetail.order.isHock) === '1'
    },
    isCancel() {
      return hasPer('order:cancel') && this.orderDetail.order.status !== 'cancel' && this.orderDetail.order.status !== 'reject'
    },
    isAudit() {
      return hasPer('auditor:approval') && this.isApproval
    },
    orderPay() {
      this.paydialogVisible = true
    },
    orderArchive() {
      this.archivedialogVisible = true
    },
    orderRepay() {
      this.repaydialogVisible = true
    },
    orderClear() {
      this.cleardialogVisible = true
    },
    updateClearDialogVisible(val) {
      this.cleardialogVisible = val
    },
    updateRepayDialogVisible(val) {
      this.repaydialogVisible = val
    },
    orderAudit() {
      this.authDialogVisible = true
    },
    updatepayDialogVisible(val) {
      this.paydialogVisible = val
    },
    updateArchiveDialogVisible(val) {
      this.archivedialogVisible = val
    },
    updateAuthDialogVisible(val) {
      this.authDialogVisible = val
    },
    operationComplete(action) {
      this.$emit('operation:complete', action)
    }
  }
}

</script>
<style scoped>
.content-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .el-button {
    margin-top: 10px;
    height: 30px;
    width: 80px;
    margin-right: 10px;
    font-size: 16px;
  }
}
</style>
